enum ServiceItemStatus {
	New = "New",
	ReadyForExecution = "ReadyForExecution",
	OrderedProduction = "OrderedProduction",
	OrderExternal = "OrderExternal",
	Closed = "Closed"
}

export default ServiceItemStatus;
